var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcView16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: 949494,
  fillRule: "evenodd",
  d: "M8 13c-4.667 0-7-5-7-5s2.333-5 7-5 7 5 7 5-2.333 5-7 5M4.212 9.135A9 9 0 0 1 3.314 8c.229-.34.53-.74.898-1.135C5.178 5.83 6.436 5 8 5s2.822.83 3.788 1.865c.369.395.67.794.898 1.135-.229.34-.53.74-.898 1.135C10.822 10.17 9.564 11 8 11s-2.822-.83-3.788-1.865",
  clipRule: "evenodd"
})));
export default SvgIcView16;